export default {
  paymentCollection: [],
};
